// src/middleware/LoginMiddleware.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const LoginMiddleware = () => {
  const token = localStorage.getItem("kkm_auth");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default LoginMiddleware;
